import { useLocation } from "react-router-dom";
import { QRCode } from 'react-qrcode-logo';
import { useState, useCallback, useEffect } from "react";

import classes from "./ConnectModal.module.scss";

import ConnectLogo from '../../assets/images/synergyConnectLogo.svg'
import ClsIcon from '../../assets/images/close_icon.svg'
import qrLogo from '../../assets/images/qrLogo.svg'
import appStore from '../../assets/images/appstroe.svg'
import hillLeft from '../../assets/images/botm_hill_1.svg'
import hillRight from '../../assets/images/botm_hill_2.svg'
import { ButtonLoader } from '../../Components/ButtonLoader/ButtonLoader';
import CopyIcon from '../../assets/images/copyicon.svg'
import CopyTick from '../../assets/images/copied_tick.png'

export interface ConnectModalProps {
    step: any;
    updateParentState(firstArgument: "splash" | "email" | "walletReady" | "close"): any
    fullView?: boolean
}

export const ConnectModal = ({ step, updateParentState, fullView }: ConnectModalProps) => {

    const { search } = useLocation();
    const [emailValid, setEmailValid] = useState<boolean>(false)
    const [email, setEmail] = useState<string>('');
    const [error, setError] = useState<undefined | string>(undefined);
    const [loading, setLoading] = useState<boolean>(false);
    const [qr, setQr] = useState<any>("");
    const [qrText, setQrText] = useState<any>("");
    const [copy, setCopy] = useState<boolean>(false);
    // const [finalQr, setfinalQr] = useState<any>( process.env.REACT_APP_SINGLE_DOWNLOAD_LINK ? `${process.env.REACT_APP_SINGLE_DOWNLOAD_LINK}/download` :  `${window.location.origin}/download` ) ;
    const [finalQr, setfinalQr] = useState<any>(`${process.env.REACT_APP_SINGLE_DOWNLOAD_LINK}/download`);
    const [influencerId, setInfluencerId] = useState<string>("");

    const clsHandler = () => {
        window.parent.postMessage(
            JSON.stringify({ functionToRun: "closeIframe", message: "qr" }),
            "*"
        );
        updateParentState("close");
    }

    // QR code stuff

    useEffect(() => {


        //Get URL param values
        const queryParameters: any = new URLSearchParams(search)
        //For Case sensitivity, create new var with empty & then append Params in lower format
        const lowerCaseParams = new URLSearchParams();

        for (const [name, value] of queryParameters) {
            lowerCaseParams.append(name.toLowerCase(), value);
        }
        const qrParam = lowerCaseParams.get("wcurl")?.trim() || "";
        const decodedUri = atob(qrParam);
        console.log({decodedUri});
        
        // const decodedUri = superAppWCdeeplink + qrParam;
        // const campId = lowerCaseParams.get("campaignid")?.trim()
        setQr(decodedUri !== '' && decodedUri !== undefined ? decodedUri : '')
        // setQrText(qrParam !== '' && qrParam !== undefined ? qrParam : '')
        setQrText(decodedUri !== '' && decodedUri !== undefined ? decodedUri : '')

        setfinalQr(decodedUri)


        // Landing email screen directly
        const emailStepFromUrl = lowerCaseParams.get("step")?.trim();
        if (emailStepFromUrl === 'email') {
            updateParentState("email");
        }

    }, [])

    const copyHandler = () => {
        setCopy(true)
        if (qrText !== '') {
            // setCopy(true)
            navigator.clipboard.writeText(qrText);
        }
    }


    return (
        <>

            <div className={`${fullView ? classes.fullView : classes.backdrop}`} >

                <section className={`${classes.modalWrap} ${step === 'splash' ? classes.splashScreen : classes.innerScreen} ${step === 'email' && classes.innerScreen}`}>
                    <div className={classes.bgFill}></div>
                    <i className={classes.clsbtn}><img src={ClsIcon} onClick={clsHandler} /></i>
                    <i className={classes.logoWrap}><img src={ConnectLogo} /></i>

                    {step === 'splash' &&
                        <>
                            <div className={classes.heading}>Scan with your synergy wallet <br />to connect.</div>
                            <div className={classes.contentBox}>
                                <div className={classes.qrBox}>
                                    {qr !== '' ?
                                        <>

                                            <QRCode
                                                id="myqr"
                                                value={qr}
                                                // logoImage={qrLogo}
                                                size={220}
                                                logoWidth={60}
                                            // logoHeight={40}
                                            />
                                            <div className={`${classes.bottomLink} ${classes.copyClipboard}`} onClick={copyHandler} >
                                                {copy ?
                                                    <div className={classes.copyblock}>
                                                        <span className={classes.copyTick}><img src={CopyTick} /></span>
                                                        <span className={classes.afterCopy}>AgentConnect Link Copied</span>
                                                    </div>
                                                    : <div className={classes.copyblock}>
                                                        <span className={classes.copyImg}><img src={CopyIcon} /></span>
                                                        <span className={classes.beforeCopy}>Copy AgentConnect Link</span>
                                                    </div>

                                                }
                                            </div>
                                        </>
                                        : <p className={classes.noQr}>No QR code</p>
                                    }
                                </div>
                            </div>
                        </>
                    }
                </section>

            </div>
        </>
    )
}
